import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { WebFormFieldComponent } from './web-form-field.component';

@NgModule({
  declarations: [
    WebFormFieldComponent // Declare the WebFormFieldComponent
  ],
  imports: [
    CommonModule,       // Common module for common directives
    ReactiveFormsModule // Reactive forms module for form controls
  ],
  exports: [
    WebFormFieldComponent // Export the WebFormFieldComponent
  ]
})
export class WebFormFieldModule { }